export class Role {
    roleID: string;
    name: string;

}
